/*
 * Product comparison, matching the behaviour of the shop's own site: pick up to
 * four fittings, keep them while browsing, then read them side by side.
 *
 * The whole comparison lives in localStorage rather than on the cart or an
 * account, because it is a browsing aid, not an order. Each card writes its own
 * facts onto its compare button, so the tray and the table can be drawn on any
 * page without asking Shopify for the products again.
 */
(function () {
  var KEY = 'elshrouk.compare.v1';
  var MAX = 4;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.slice(0, MAX) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
    } catch (e) {
      /* A private window can refuse to store; comparing still works for the page. */
    }
  }

  function itemFrom(button) {
    var d = button.dataset;
    return {
      id: d.cmp,
      title: d.title || '',
      img: d.img || '',
      url: d.url || '',
      price: d.price || '',
      old: d.old || '',
      save: d.save || '',
      vendor: d.vendor || '',
      type: d.type || '',
      finish: d.finish || '',
      sku: d.sku || '',
      avail: d.avail || ''
    };
  }

  function esc(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function syncButtons() {
    var ids = read().map(function (i) { return i.id; });
    document.querySelectorAll('[data-cmp]').forEach(function (b) {
      var on = ids.indexOf(b.dataset.cmp) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'إزالة من المقارنة: ' : 'أضف للمقارنة: ') + (b.dataset.title || ''));
    });
  }

  function renderTray() {
    var tray = document.getElementById('esCompareTray');
    if (!tray) return;
    var list = read();
    tray.hidden = list.length === 0;
    if (!list.length) { tray.innerHTML = ''; return; }
    tray.innerHTML =
      '<div class="es-cmp-tray__items">' +
      list.map(function (i) {
        return '<img src="' + esc(i.img) + '" alt="' + esc(i.title) + '" title="' + esc(i.title) + '" loading="lazy" decoding="async">';
      }).join('') +
      '</div>' +
      '<div class="es-cmp-tray__text"><b>' + list.length + ' منتج في المقارنة</b>' +
      '<span>اختار حتى 4 منتجات وشوف الفرق بسرعة</span></div>' +
      '<div class="es-cmp-tray__actions">' +
      '<button type="button" class="es-cmp-btn es-cmp-btn--solid" data-cmp-open>عرض المقارنة</button>' +
      '<button type="button" class="es-cmp-btn" data-cmp-clear>مسح</button>' +
      '</div>';
  }

  function rowsFor(list) {
    var rows = [
      ['البراند', 'vendor'],
      ['الفئة', 'type'],
      ['التشطيب', 'finish'],
      ['الكود', 'sku'],
      ['السعر', 'price'],
      ['قبل الخصم', 'old'],
      ['التوفر', 'avail']
    ];
    return rows.map(function (r) {
      return '<div class="es-cmp-grid__label">' + r[0] + '</div>' +
        list.map(function (i) {
          return '<div class="es-cmp-grid__value">' + esc(i[r[1]] || '—') + '</div>';
        }).join('');
    }).join('');
  }

  function openModal() {
    var list = read();
    var modal = document.getElementById('esCompareModal');
    if (!list.length || !modal) return;
    modal.querySelector('[data-cmp-body]').innerHTML =
      '<div class="es-cmp-grid" style="--cols:' + list.length + '">' +
      '<div class="es-cmp-grid__label es-cmp-grid__label--top">المنتج</div>' +
      list.map(function (i) {
        return '<div class="es-cmp-grid__product">' +
          '<img src="' + esc(i.img) + '" alt="' + esc(i.title) + '" loading="lazy" decoding="async">' +
          '<b>' + esc(i.title) + '</b>' +
          '<button type="button" data-cmp-remove="' + esc(i.id) + '">إزالة</button>' +
          '</div>';
      }).join('') +
      rowsFor(list) +
      '<div class="es-cmp-grid__label">إجراء</div>' +
      list.map(function (i) {
        return '<div class="es-cmp-grid__value"><a class="es-cmp-btn es-cmp-btn--solid" href="' + esc(i.url) + '">فتح المنتج</a></div>';
      }).join('') +
      '</div>';
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var close = modal.querySelector('[data-cmp-close]');
    if (close) close.focus();
  }

  function closeModal() {
    var modal = document.getElementById('esCompareModal');
    if (!modal) return;
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cmp]');
    if (toggle) {
      event.preventDefault();
      var list = read();
      var id = toggle.dataset.cmp;
      var at = list.findIndex(function (i) { return i.id === id; });
      if (at > -1) {
        list.splice(at, 1);
      } else {
        /* Four is the most that stays readable side by side, so the oldest
           choice drops out rather than the click doing nothing. */
        if (list.length >= MAX) list.shift();
        list.push(itemFrom(toggle));
      }
      write(list);
      syncButtons();
      renderTray();
      return;
    }

    if (event.target.closest('[data-cmp-open]')) { openModal(); return; }
    if (event.target.closest('[data-cmp-clear]')) {
      write([]); syncButtons(); renderTray(); closeModal(); return;
    }
    if (event.target.closest('[data-cmp-close]') || event.target.hasAttribute('data-cmp-backdrop')) {
      closeModal(); return;
    }
    var remove = event.target.closest('[data-cmp-remove]');
    if (remove) {
      var kept = read().filter(function (i) { return i.id !== remove.dataset.cmpRemove; });
      write(kept); syncButtons(); renderTray();
      if (kept.length) { openModal(); } else { closeModal(); }
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeModal();
  });

  function start() { syncButtons(); renderTray(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Collection filtering and pagination swap the grid in place, so the new
     buttons need their state painted again. */
  document.addEventListener('shopify:section:load', start);
  window.addEventListener('pageshow', start);
})();
